import cx from 'classnames';
import Portal from '../misc/Portal.js';
import React from 'react';
import ShareModal from '../share/ShareModal.js';
import './FeedPostBottomBar.css';

class FeedPostBottomBar extends React.Component {
  state = {
    sharing: false,
  }

  _closeSharing = () => {
    this.setState({sharing: false});
  }

  _likeToggle = () => {
    if (!this.props.activityUrl) {
      return;
    }
    this.props.onLike(this.props.activityUrl);
  };

  _share = () => {
    this.setState({sharing: true});
  }

  render() {
    const {buyUrl, nextLink, shareHref, liked, likes} = this.props;
    let shareBtn = null;
    if (shareHref) {
      shareBtn = (
        <li>
          <a onClick={this._share}>
            <i className="fa fa-share-alt"></i> Share
          </a>
        </li>
      );
    }

    let buyBtn = null;
    if (buyUrl) {
      buyBtn = (
        <li>
          <a href={buyUrl} target="_blank">
            <i className="fa fa-picture-o"></i> Buy Photo
          </a>
        </li>
      );
    }

    let nextBtn = null;
    if (nextLink) {
      nextBtn = (
        <div className="toright">
          <ul>
            <li className="gonext">
              <a href={nextLink.href} className="link-effect">
                {nextLink.title} &gt;&gt;
              </a>
            </li>
          </ul>
        </div>
      );
    }

    let likeBtn = null;
    if (likes !== undefined) {
      likeBtn = (
        <li>
          <a onClick={this._likeToggle}>
            <i className={cx('fa', 'fa-arrow-up', {'FeedPostBottomBarLikeButton--liked': liked})}></i> Like ({likes})
          </a>
        </li>
      );
    }

    let sharing = null;
    if (this.state.sharing) {
      sharing = (
        <Portal>
          <ShareModal url={this.props.shareHref} extra={this.props.shareExtra} onCloseRequested={this._closeSharing} />
        </Portal>
      );
    }

    return (
      <div className="post-bottom">
        <div className="toleft">
          <ul>
            {shareBtn}
            {buyBtn}
            {likeBtn}
          </ul>
        </div>
        {nextBtn}
        {sharing}
      </div>
    );
  }
}

export default FeedPostBottomBar;
